(() => {
  const silverPattern = /(925\s*silber|sterlingsilber|silber\s*farben|silver)/i;

  const setSilverInputs = (inputs, checked) => {
    inputs.forEach((input) => {
      input.checked = checked;
    });
  };

  const combineSilverFilter = (root = document) => {
    root.querySelectorAll('form').forEach((form) => {
      const labels = [...form.querySelectorAll('.facets__label')];
      const silverLabels = labels.filter((label) => {
        const text = label.querySelector('.facet-checkbox__text-label');
        return text && silverPattern.test(text.textContent);
      });
      if (silverLabels.length === 0) return;

      const inputs = silverLabels.map((label) => label.querySelector('input[type="checkbox"]')).filter(Boolean);
      const primary = silverLabels.find((label) => /925\s*silber/i.test(label.textContent)) || silverLabels[0];
      const primaryInput = primary.querySelector('input[type="checkbox"]');
      const primaryText = primary.querySelector('.facet-checkbox__text-label');
      const isActive = inputs.some((input) => input.checked);

      setSilverInputs(inputs, isActive);
      if (primaryText) primaryText.textContent = '925 Silber';
      silverLabels.forEach((label) => {
        const item = label.closest('li');
        if (item && label !== primary) item.hidden = true;
      });

      if (primaryInput && !primaryInput.dataset.silverCombined) {
        primaryInput.dataset.silverCombined = 'true';
        primaryInput.addEventListener('change', () => setSilverInputs(inputs, primaryInput.checked), { capture: true });
      }
    });

    root.querySelectorAll('.active-facets').forEach((container) => {
      const activeButtons = [...container.querySelectorAll('.active-facets__button')].filter((button) => silverPattern.test(button.textContent));
      activeButtons.forEach((button, index) => {
        if (index > 0) {
          button.closest('facet-remove')?.setAttribute('hidden', '');
          return;
        }
        const textNode = [...button.querySelector('.active-facets__button-inner').childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
        if (textNode) textNode.textContent = ' Schmuckmaterial: 925 Silber ';
        if (!button.dataset.silverRemove) {
          button.dataset.silverRemove = 'true';
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const url = new URL(window.location.href);
            const silverInputs = [...document.querySelectorAll('.facets__label input[type="checkbox"]')].filter((input) => {
              const text = input.closest('.facets__label')?.querySelector('.facet-checkbox__text-label');
              return text && silverPattern.test(text.textContent);
            });
            const byName = new Map();
            silverInputs.forEach((input) => {
              if (!byName.has(input.name)) byName.set(input.name, new Set());
              byName.get(input.name).add(input.value);
            });
            byName.forEach((values, name) => {
              const keep = url.searchParams.getAll(name).filter((value) => !values.has(value));
              url.searchParams.delete(name);
              keep.forEach((value) => url.searchParams.append(name, value));
            });
            window.location.assign(url.toString());
          });
        }
      });
    });
  };

  combineSilverFilter();
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) combineSilverFilter(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
